import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

import { fetchCrmReport } from "./CrmReportThunk";

const initialState = {
  list: [],
  totalLeads: 0,
  loading: false,

  filters: {
    reportType: "source",

    fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
    toDate: dayjs().endOf("month").format("YYYY-MM-DD"),

    source_id: null,
    status_id: null,
    purpose_id: null,
  },
};

const crmReportSlice = createSlice({
  name: "crmReport",

  initialState,

  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCrmReport.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchCrmReport.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.totalLeads = action.payload.totalLeads;
      })

      .addCase(fetchCrmReport.rejected, (state, action) => {
        state.loading = false;
        console.log("CRM REPORT ERROR:", action.payload);
      });
  },
});

export const {
  setFilters,
} = crmReportSlice.actions;

export default crmReportSlice.reducer;